import { render, staticRenderFns } from "./changeBKFamilyLeader.vue?vue&type=template&id=65b1a876&scoped=true"
import script from "./changeBKFamilyLeader.vue?vue&type=script&lang=js"
export * from "./changeBKFamilyLeader.vue?vue&type=script&lang=js"
import style0 from "./changeBKFamilyLeader.vue?vue&type=style&index=0&id=65b1a876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b1a876",
  null
  
)

export default component.exports